import axiosService from '../axios';
import { getContract, getClient, isAPLink } from '../client';
import { VoteListParams } from './typing';
import { $BigNumber, nameToNumeric } from 'common/utils/met';
import { transact } from '../transact' 
import { message } from 'antd';
import { BACKUP_PLAN_OPTIONS } from '@/page/BackupNode/planOptions';
// const env = process.env.REACT_APP_NET;
const daoCode = process.env.REACT_APP_DAOCODE
const proposeContract = process.env.REACT_APP_PROPOSE
const planContract = process.env.REACT_APP_PLAN

console.log(daoCode,'daoCode-');

// 状态
export const planStatus = {
    1: '未激活',
    2: '进行中',
    3: '已暂停',
};
// 状态
export const issuesStatus = {
    1: '未启用',
    2: '进行中',
    3: '已结束',
};

/**
 * 对字符串（二进制）前补0
 * @param {*} str
 * @param {*} n 总长度
 * @returns
 */
export const zeroPadding = (str, n) => (Array(n).join('0') + str).slice(-n);

/**
 * 十进制转二进制
 * @returns
 */
export const decimalToBinary = num => Number(num).toString(2);

/**
 * 二进制转十进制
 * @param {*} bin
 * @returns
 */
export const binaryToDecimal = bin => parseInt(bin, 2);

// API
export default class Server {
    public static base = {
        baseUrl: '',
        baseCaptchaUrl: process.env.REACT_APP_NET === 'production' ? '/api' : 'https://amaxscan.ambt.art/api/stats',

        baseTokenUrl: process.env.REACT_APP_NET === 'production' ? 'https://amaxscan.io/api/stats' : 'https://amaxscan.amaxtest.com/api/stats',

        baseMultiApiUrl:process.env.REACT_APP_NET === 'production' ? 'https://m.aplink.app/api/pptoken/v1/amax_msig/get_msig_res' : 'https://m-ap.amaxtest.com/api/pptoken/v1/amax_msig/get_msig_res',
        
        contract_name: 'amax',
        contract_reward: 'amax.reward',
    };

    public static async getMultiList<T>(params:any): Promise<T> {
        return axiosService({
            url: `${this.base.baseMultiApiUrl}`,
            method: 'get',
            params,
        });
    }

    public static async getMultiDetail<T>(params:any): Promise<T> {
        return axiosService({
            url: `${this.base.baseMultiApiUrl}`,
            method: 'get',
            params,
        });
    }

    public static async fileUpload<T>(data: any): Promise<T> {
        return axiosService({
            url: `${process.env.REACT_APP_IMAGE}/api/nft/v1/uploader/image`,
            method: 'post',
            data,
        });
    }

    public static async getProduceList<T>(params: Partial<VoteListParams>): Promise<T> {
        return axiosService({
            url: `${this.base.baseTokenUrl}/produce/list`,
            method: 'get',
            params,
        });
    }

    public static async getProduceListByUser<T>(voter: string): Promise<T> {
        return axiosService({
            url: `${this.base.baseTokenUrl}/produce/voteInfolist`,
            method: 'get',
            params: {
                voter,
            },
        });
    }
    public static async getMyVoteInfo<T>(voter: string): Promise<T> {
        return axiosService({
            url: `${this.base.baseTokenUrl}/produce/voteInfo`,
            method: 'get',
            params: {
                voter,
            },
        });
    }
    public static async getFriendsVote<T>(creater: string): Promise<T> {
        return axiosService({
            url: `${this.base.baseTokenUrl}/produce/votesByCreater`,
            method: 'get',
            params: {
                creater,
            },
        });
    }

    public static async getMyDaoInfo<T>(daoCode: string): Promise<T> {
        return axiosService({
            url: `${this.base.baseTokenUrl}/produce/daoInfo`,
            method: 'get',
            params: {
              daoCode,
            },
        });
    }

    // 文档：  https://www.processon.com/view/link/647ee693e840aa69e0f182ab 访问密码：mini

    // vote 更换节点列表
    // amcli --url http://127.0.0.1:8888 push action amax vote '{"voter": "zx1ynrgptayf", "producers": ["produceraabe", "produceraabf", "produceraabg", "produceraabh", "produceraabi", "produceraabj", "produceraabk", "produceraabl", "produceraabm", "produceraabn", "produceraabo", "produceraabp", "produceraabq", "produceraabr", "produceraabs", "produceraabt", "produceraabu", "produceraabv", "produceraabw", "produceraabx", "produceraaby", "produceraabz", "producerabba", "producerabbb", "producerabbc", "producerabbd", "producerabbe", "producerabbf", "producerabbg", "producerabbh"]}' --permission zx1ynrgptayf@active
    // amax.vote(voter='user1', producers=["produceraabe", "produceraabf", "produceraabg", "produceraabh", "produceraabi", "produceraabj", "produceraabk", "produceraabl", "produceraabm", "produceraabn", "produceraabo", "produceraabp", "produceraabq", "produceraabr", "produceraabs", "produceraabt", "produceraabu", "produceraabv", "produceraabw", "produceraabx", "produceraaby", "produceraabz", "producerabba", "producerabbb", "producerabbc", "producerabbd", "producerabbe", "producerabbf", "producerabbg", "producerabbh"])

    // addvote 增加投票
    // amcli --url http://127.0.0.1:8888 push action amax addvote '{"voter": "42xgpslnf45j", "votes": "1000.0000 VOTE"}' --permission 42xgpslnf45j@active
    // amax.addvote(voter='user', votes: '1000.0000 VOTE')

    // subvote 撤票
    // amcli --url http://127.0.0.1:8888 push action amax subvote '{"voter": "42xgpslnf45j", "votes": "1000.0000 VOTE"}' --permission 42xgpslnf45j@active
    // amax.subvote(voter='user', votes: '1000.0000 VOTE')

    public static async vote<T>(user: string, amount: string, producers: string[], isChangeProducers:boolean): Promise<T> {
        if (!(window as any).armadillo) {
            const client = await getClient();
            return client.transaction([this.base.contract_name], ({ amax }) => {
                amax.addvote(user, `${$BigNumber(amount || 0).toFixed(4,1)} VOTE`);
                !isChangeProducers && amax.vote(user, producers);
            });
        }else{
            const actions:any = [
                {
                    account:'amax',
                    name:'addvote',
                    data:{
                        voter:user,
                        votes: `${$BigNumber(amount || 0).toFixed(4,1)} VOTE`
                    }
                }
            ]
            if (!isChangeProducers) {
                actions.push(
                    {
                        account:'amax',
                        name:'vote',
                        data:{
                            voter:user,
                            producers
                        }
                    }
                )
            }
            return transact(actions)
        }
    }

    public static async addVote<T>(user: string, amount: string | number): Promise<T> {
        if (!(window as any).armadillo) {
            const contract = await getContract(this.base.contract_name);
            return contract.addvote(user, `${$BigNumber(amount || 0).toFixed(4,1)} VOTE`);
        }else{
            const actions:any = [
                {
                    account:'amax',
                    name:'addvote',
                    data:{
                        voter:user,
                        votes: `${$BigNumber(amount || 0).toFixed(4,1)} VOTE`
                    }
                }
            ]
            return transact(actions)
        }
    }

    public static async reVote<T>(user: string, producers: string[]): Promise<T> {
        if (!(window as any).armadillo) {
            const contract = await getContract(this.base.contract_name);
            return contract.vote(user, producers);
        }else{
            const actions:any = [
                {
                    account:'amax',
                    name:'vote',
                    data:{
                        voter:user,
                        producers
                    }
                }
            ]
            return transact(actions)
        }
        
    }

    public static async subVote<T>(user: string, votes: string | number): Promise<T> {
        if (!(window as any).armadillo) {
            const contract = await getContract(this.base.contract_name);
            return contract.subvote(user, `${$BigNumber(votes || 0).div(10000).toFixed(4,1)} VOTE`);
        }else{
            const actions:any = [
                {
                    account:'amax',
                    name:'subvote',
                    data:{
                        voter:user,
                        votes: `${$BigNumber(votes || 0).div(10000).toFixed(4,1)} VOTE`
                    }
                }
            ]
            return transact(actions)
        }
        
    }

    public static async reward<T>(user: string): Promise<T> {
        if (!(window as any).armadillo) {
            const contract = await getContract(this.base.contract_reward);
            return contract.claimrewards(user);
        }else{
            const actions:any = [
                {
                    account:'amax.reward',
                    name:'claimrewards',
                    data:{
                        voter_name:user
                    }
                }
            ]
            return transact(actions)
        }
    }

    public static async amaxReward<T>(submitter:string,owner: string): Promise<T> {
        if (!(window as any).armadillo) {
            const contract = await getContract(this.base.contract_name);
            return contract.claimrewards(submitter,owner);
        }else{
            const actions:any = [
                {
                    account:'amax',
                    name:'claimrewards',
                    data:{
                        submitter,
                        owner
                    }
                }
            ]
            return transact(actions)
        }
        
    }
    

    public static async signUp<T>({applyData,amaxData}): Promise<T> {
        if (!(window as any).armadillo) {
            const client = await getClient();
            return client.transaction(["amax",'amax.applybp'], ({amax,amax_applybp}) => {
                amax_applybp.applybp(applyData)
                amax.regproducer(amaxData)
            })
        }else{
            const actions = [
                {
                    account:'amax.applybp',
                    name:'applybp',
                    data:applyData
                },
                {
                    account:'amax',
                    name:'regproducer',
                    data:amaxData
                }
            ]
            return transact(actions)
        }
        
    }

    public static async signUpUpdate<T>({applyData,amaxData}): Promise<T> {
        if (!(window as any).armadillo) {
            const client = await getClient();
            return client.transaction(["amax",'amax.applybp'], ({amax,amax_applybp}) => {
                amax_applybp.updatebp(applyData)
                amax.regproducer(amaxData)
            })
        }else{
            const actions = [
                {
                    account:'amax.applybp',
                    name:'updatebp',
                    data:applyData
                },
                {
                    account:'amax',
                    name:'regproducer',
                    data:amaxData
                }
            ]
            return transact(actions)
        }
    }

    public static async initiateGovernance<T>(data): Promise<T> {
        if (!(window as any).armadillo) {
            const client = await getClient();
            return client.transaction([process.env.REACT_APP_PROPOSE], ({mdao_propose}) => {
                mdao_propose.create(data)
            })
        }else{
            const actions = [
                {
                    account:process.env.REACT_APP_PROPOSE,
                    name:'create',
                    data:data
                }
            ]
            return transact(actions)
        }
        
    }

    public static async voteFor<T>(voteData): Promise<T> {
        console.log(!(window as any).armadillo,'!(window as any).armadillo');
        
        if (!(window as any).armadillo) {
            const client = await getClient();
            return client.transaction([process.env.REACT_APP_PROPOSE], ({mdao_propose}) => {
                mdao_propose.votefor(voteData)
            })
        }else{
            const actions = [
                {
                    account:process.env.REACT_APP_PROPOSE,
                    name:'votefor',
                    data:voteData
                }
            ]
            return transact(actions)
        }
        
    }

    public static async cancelProposal<T>(data): Promise<T> {
        if (!(window as any).armadillo) {
            const client = await getClient();
            return client.transaction([process.env.REACT_APP_PROPOSE], ({mdao_propose}) => {
                mdao_propose.cancel(data)
            })
        }else{
            const actions = [
                {
                    account:process.env.REACT_APP_PROPOSE,
                    name:'cancel',
                    data:data
                }
            ]
            return transact(actions)
        }
        
    }

    public static async submitPlan<T>(data,extraData): Promise<T> {
        const actions = [
            {
                account:planContract,
                name:'applybbp',
                data:data
            }
        ]
        if (extraData.amaxData) {
            actions.push(extraData.amaxData)
        }
        if (extraData.NFTData) {
            actions.push(extraData.NFTData)
        }
        if (extraData.amaeData) {
            actions.push(extraData.amaeData)
        }
        return transact(actions)
    }

    public static async withdraw<T>(data): Promise<T> {
        if (!(window as any).armadillo) {
            const client = await getClient();
            return client.transaction([process.env.REACT_APP_PLAN], ({bbptest1}) => {
                bbptest1.withdraw(data)
            })
        }else{
            const actions = [
                {
                    account:process.env.REACT_APP_PLAN,
                    name:'withdraw',
                    data:data
                }
            ]
            return transact(actions)
        }
        
    }
    


    /**获取账户余额*/
    public static async getBalanceByUser<T>(user: string, symbol: string, contract: string): Promise<T> {
        return axiosService({
            url: '/v1/chain/get_currency_balance',
            method: 'post',
            data: {
                code: contract,
                account: user,
                symbol,
            },
        });
    }


    public static async getPubkeyByAccount<T>(account_name: string): Promise<T> {
        return axiosService({
            url: '/v1/chain/get_account',
            method: 'post',
            data: {
                account_name
            },
        });
    }

    public static async getTokenList<T>(): Promise<T> {
        return axiosService({
            url: `${this.base.baseTokenUrl}/tokenstats/list`,
            method: 'post',
            data: {
                pageIndex: 1,
                pageSize: 300,
                search: '',
            },
        });
    }

    public static async getSignUpInfo<T>(user: string,code:string): Promise<T> {
        return axiosService({
            url: '/v1/chain/get_table_rows',
            method: 'post',
            data: {
                code: code,
                table: 'producers',
                scope:code,
                json: true,
                lower_bound: nameToNumeric(user),
                upper_bound: nameToNumeric(user),
            },
        });
    }

    public static async getGovernanceVoteList<T>(): Promise<T> {
        return axiosService({
            url: '/v1/chain/get_table_rows',
            method: 'post',
            data: {
                code: proposeContract,
                table: 'proposals',
                scope:proposeContract,
                json: true,
                reverse:true,
                index_position:3,
                limit:200,
                key_type:'i64',
                lower_bound: daoCode,
                upper_bound: daoCode,
            },
        });
    }

    public static async getGovernanceVoteDetail<T>(id:string): Promise<T> {
        return axiosService({
            url: '/v1/chain/get_table_rows',
            method: 'post',
            data: {
                code: proposeContract,
                table: 'proposals',
                scope:proposeContract,
                json: true,
                limit:100,
                key_type:'i64',
                lower_bound: id,
                upper_bound: id,
            },
        });
    }

    public static async getPropextra<T>(): Promise<T> {
        return axiosService({
            url: '/v1/chain/get_table_rows',
            method: 'post',
            data: {
                code: proposeContract,
                table: 'propextra',
                scope:proposeContract,
                json: true,
                limit:200,
                key_type:'i64',
            },
        });
    }

    public static async getMyVotes<T>(account:string): Promise<T> {
        return axiosService({
            url: '/v1/chain/get_table_rows',
            method: 'post',
            data: {
                code: proposeContract,
                table: 'votes',
                scope:proposeContract,
                json: true,
                key_type:'i64',
                index_position:2,
                limit:100,
                reverse:true,
                lower_bound: account,
                upper_bound: account,
            },
        });
    }

    public static async getMyStakedAMAX<T>(account:string): Promise<T> {
        return axiosService({
            url: '/v1/chain/get_table_rows',
            method: 'post',
            data: {
                code: 'amax',
                table: 'voters',
                scope:'amax',
                json: true,
                key_type:'i64',
                limit:100,
                reverse:true,
                lower_bound: account,
                upper_bound: account,
            },
        });
    }

    public static async getUserPlan<T>(account?:string): Promise<T> {
        return axiosService({
            url: '/v1/chain/get_table_rows',
            method: 'post',
            data: {
                code: planContract,
                table: 'bbps',
                scope:planContract,
                json: true,
                key_type:'i64',
                limit:500,
                reverse:true,
                lower_bound: account,
                upper_bound: account,
            },
        });
    }
    public static async getPlanInfo<T>(id?:string | number): Promise<T> {
        const res:any = await axiosService({
            url: '/v1/chain/get_table_rows',
            method: 'post',
            data: {
                code: planContract,
                table: 'bbpplans',
                scope:planContract,
                json: true,
                key_type:'i64',
                limit:200,
                reverse:true,
                lower_bound: id,
                upper_bound: id,
            },
        });
        const staticPlan = BACKUP_PLAN_OPTIONS.find((item) => item.id === Number(id))
        if (!staticPlan || !res?.rows?.length) {
            return res
        }

        return {
            ...res,
            rows: res.rows.map((row:any) => ({
                ...staticPlan,
                ...row,
                quants: staticPlan.quants,
                nfts: staticPlan.nfts,
                min_sum_quant: staticPlan.min_sum_quant,
                text: staticPlan.text,
                apply_balance: row.total_bbp_quota - row.fulfilled_bbp_quota,
            })),
        } as T
    }

    public static async getNFTByAccount<T>(account:string,nftId:number): Promise<T> {
        return axiosService({
            url: '/v1/chain/get_table_rows',
            method: 'post',
            data: {
                code: 'amax.ntoken',
                table: 'accounts',
                scope:account,
                json: true,
                key_type:'i64',
                limit:100,
                reverse:true,
                lower_bound: nftId,
                upper_bound: nftId,
            },
        });
    }

    public static async getPlanRecords<T>(plan_id:string | number): Promise<T> {
        let middle = 4294967296
        let lower_bound = $BigNumber(plan_id).times(middle)
        let upper_bound = $BigNumber(plan_id).times(middle).plus(middle)
        return axiosService({
            url: '/v1/chain/get_table_rows',
            method: 'post',
            data: {
                code: planContract,
                table: 'bbps',
                scope:planContract,
                json: true,
                index_position:2,
                key_type:'i64',
                limit:10,
                reverse:true,
                lower_bound: lower_bound,
                upper_bound: upper_bound,
            },
        });
    }

}
